<template>
  <CustomModal :is-open="isOpen" @close="$emit('close')">
    <div
      class="w-full max-w-md rounded-2xl bg-white dark:bg-black p-2 md:p-6 flex flex-col items-center"
    >
      <!-- Parler Logo -->
      <div class="flex justify-center items-center mt-2 mb-4">
        <img
          :src="ParlerLogo"
          alt="Parler Logo"
          class="w-16 h-16 md:w-20 md:h-20 shadow-md"
        />
      </div>
      <!-- Headline -->
      <h2
        class="text-md md:text-xl font-semibold text-center mb-4 text-black dark:text-white"
      >
        Engage. Earn. Repeat. All On Parler.
      </h2>
      <!-- Features List -->
      <div class="flex flex-col gap-4 w-full mb-6">
        <div class="flex items-start gap-3">
          <img :src="PersonalizeIcon" alt="Personalize" class="size-6 md:size-8 mt-1" />
          <div>
            <div class="font-semibold text-black dark:text-white text-sm md:text-base">
              Personalize your feed
            </div>
            <div class="text-xs md:text-sm text-gray-600 dark:text-gray-400">
              Connect with friends, follow creators, and see more of what you care about.
            </div>
          </div>
        </div>
        <div class="flex items-start gap-3">
          <img :src="GrowIcon" alt="Grow" class="size-6 md:size-8 mt-1" />
          <div>
            <div class="font-semibold text-black dark:text-white text-sm md:text-base">
              Grow your influence
            </div>
            <div class="text-xs md:text-sm text-gray-600 dark:text-gray-400">
              Share your voice, build your audience, and become someone people want to
              hear from.
            </div>
          </div>
        </div>
        <div class="flex items-start gap-3">
          <img :src="EarnIcon" alt="Earn" class="size-6 md:size-8 mt-1" />
          <div>
            <div class="font-semibold text-black dark:text-white text-sm md:text-base">
              Earn rewards
            </div>
            <div class="text-xs md:text-sm text-gray-600 dark:text-gray-400">
              Engage with the community and earn $OPT for growing your network.
            </div>
          </div>
        </div>
        <div class="flex items-start gap-3">
          <img :src="StartIcon" alt="Start" class="size-6 md:size-8 mt-1" />
          <div>
            <div class="font-semibold text-black dark:text-white text-sm md:text-base">
              Start a streak
            </div>
            <div class="text-xs md:text-sm text-gray-600 dark:text-gray-400">
              Stay active by posting and engaging daily to grow your Streak.
            </div>
          </div>
        </div>
      </div>
      <!-- Buttons -->
      <div
        @click="handleLogin"
        class="cursor-pointer select-none flex items-center justify-center w-full py-3 rounded-full bg-primary text-white text-sm md:text-lg font-semibold mb-3 shadow-md hover:opacity-90 transition"
      >
        Login or Sign Up
      </div>
      <div
        @click="$emit('close')"
        class="cursor-pointer select-none flex items-center justify-center w-full py-3 rounded-full border-2 border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 text-sm md:text-lg font-semibold bg-white hover:bg-gray-100 dark:bg-black dark:hover:bg-gray-900 transition"
      >
        Maybe later
      </div>
    </div>
  </CustomModal>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";
import { useRouter } from "vue-router";
import CustomModal from "@/components/CustomModal.vue";
import ParlerLogo from "@/assets/parler/parler-logo.svg";
import PersonalizeIcon from "@/assets/parler/personalize.svg";
import GrowIcon from "@/assets/parler/grow.svg";
import EarnIcon from "@/assets/parler/earn.svg";
import StartIcon from "@/assets/parler/start.svg";

defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  action: {
    type: String,
    required: false,
    default: "login",
  },
});

const emit = defineEmits(["close"]);
const router = useRouter();

const handleLogin = () => {
  // Get the current route for redirect after login
  const currentRoute = router.currentRoute.value.fullPath;
  // Check if there's already a referral code in the current route
  const currentRef = router.currentRoute.value.query.ref;
  // Use site-admin referral code if not present
  const referralCode = currentRef || "cgryXSeGoy";
  // Navigate to login with redirect and referral code
  router.push({
    path: "/login",
    query: {
      redirect: currentRoute,
      ref: referralCode,
    },
  });
  emit("close");
};
</script>

<style scoped>
.bg-primary {
  background-color: #e50038;
}
</style>
